module.exports = __webpack_public_path__ + "static/badge_small_tool-b6102e4de58a6ef75f6b4e5ff70bdc21.svg";